import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { logConsentWithRetry } from '../utils/consentAPI';
import './CookieConsent.css';

const CookieConsent = ({ onConsent }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // Zkontroluj, zda již uživatel nerozhodl o cookies
    const consent = localStorage.getItem('cookieConsent');

    if (consent === null) {
      // Krátké zpoždění pro smooth animaci při načtení stránky
      setTimeout(() => {
        setIsVisible(true);
        setTimeout(() => setIsAnimating(true), 50);
      }, 1000);
    } else {
      // Pokud již má consent, zavolej callback
      const hasConsent = consent === 'true';
      if (onConsent) {
        onConsent(hasConsent);
      }
    }
  }, [onConsent]);

  const handleAccept = async () => {
    // Uložit souhlas do localStorage
    localStorage.setItem('cookieConsent', 'true');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());

    // Logovat do API (ne-blokující)
    logConsentWithRetry(true).catch(err => {
      console.error('API logging failed:', err);
    });

    // Animace zavření
    setIsAnimating(false);
    setTimeout(() => {
      setIsVisible(false);
      if (onConsent) {
        onConsent(true);
      }
    }, 300);
  };

  const handleReject = async () => {
    // Uložit odmítnutí do localStorage
    localStorage.setItem('cookieConsent', 'false');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());

    // Logovat do API (ne-blokující)
    logConsentWithRetry(false).catch(err => {
      console.error('API logging failed:', err);
    });

    // Animace zavření
    setIsAnimating(false);
    setTimeout(() => {
      setIsVisible(false);
      if (onConsent) {
        onConsent(false);
      }
    }, 300);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <>
      {/* Backdrop overlay */}
      <div
        className={`cookie-consent-backdrop ${isAnimating ? 'show' : ''}`}
        onClick={handleReject}
      />

      {/* Cookie consent banner */}
      <div className={`cookie-consent-banner ${isAnimating ? 'show' : ''}`}>
        <div className="cookie-consent-content">
          <div className="cookie-consent-icon">
            🍪
          </div>
          <div className="cookie-consent-text">
            <h3 className="cookie-consent-title">Používáme cookies</h3>
            <p className="cookie-consent-description">
              Pro zlepšení vašeho zážitku a marketingové účely používáme cookies a retargetingové technologie.
              Kliknutím na "Souhlasím" povolíte všechny cookies.
            </p>
            <a
              href="https://fitelites3.s3.eu-central-1.amazonaws.com/images/gdpr.pdf"
              target="_blank"
              rel="noreferrer noopener"
              className="cookie-consent-link"
            >
              Více o zpracování osobních údajů (GDPR)
            </a>
          </div>
          <div className="cookie-consent-buttons">
            <button
              onClick={handleAccept}
              className="cookie-consent-btn cookie-consent-btn-accept"
              type="button"
            >
              Souhlasím
            </button>
            <button
              onClick={handleReject}
              className="cookie-consent-btn cookie-consent-btn-reject"
              type="button"
            >
              Odmítnout
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

CookieConsent.propTypes = {
  onConsent: PropTypes.func,
};

CookieConsent.defaultProps = {
  onConsent: null,
};

export default CookieConsent;
